import { tierDailyAPI } from "./api";

export const getResidents = async () => {
  try {
    const res = await tierDailyAPI.getResidents();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getBlocks = async (resident_id) => {
  try {
    if (!resident_id) return [];
    const res = await tierDailyAPI.getBlocks(resident_id);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getWorkGroupDicts = async () => {
  try {
    const res = await tierDailyAPI.getWorkGroupDicts();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getWorkTaskFactDaily = async (date_, resident_id, block_id, work_group_dict_id) => {
  try {
    const res = await tierDailyAPI.getWorkTaskFactDaily(date_, resident_id, block_id, work_group_dict_id);
    
    // Бэкенд уже возвращает сгруппированные данные в удобном формате
    // Проверяем разные варианты структуры ответа
    if (Array.isArray(res)) {
      return res;
    }
    if (res?.data && Array.isArray(res.data)) {
      return res.data;
    }
    if (res?.data?.data && Array.isArray(res.data.data)) {
      return res.data.data;
    }
    
    return [];
  } catch (e) {
    console.error('getWorkTaskFactDaily error:', e);
    return [];
  }
};

